export default {"src":"/_next/static/media/right-arrow.02717587.svg","height":512,"width":448,"blurWidth":0,"blurHeight":0};